import { useQueries } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import { SnakeMeta } from '@toggle/toggle';

import { fetchSnakeMeta } from '~/services/overview-widget/overview-widget-service';

export const QUERY_KEY_SNAKE_META = 'QUERY_KEY_SNAKE_META';

export const useMultipleSnakesMeta = (snakes: string[]) => {
  const queries = snakes.map(snake => ({
    queryKey: [QUERY_KEY_SNAKE_META, snake],
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchSnakeMeta(snake, signal),
    staleTime: getTimeTillEndOfDayMs(),
  }));

  return useQueries({
    queries,
    combine: results => {
      return {
        data: results.map(r => r.data).filter(Boolean) as SnakeMeta[],
        isFetching: results.some(r => r.isFetching),
      };
    },
  });
};
